<!--
 * @Author: Zj
 * @Date: 2022-01-10 14:12:27
 * @LastEditTime: 2024-02-22 14:38:07
 * @LastEditors: zj
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gdp-cloud-app\src\views\medical-edu\detail\live\index.vue
-->
<template>
  <div class="live">
    <div class="fixedDiv">
      <div class="coverImg" v-if='detail.liveStatus!=="进行中"'>
        <span class="status">{{detail.liveStatus}}</span>
        <img :src='src' />
      </div>
      <div class="coverImg" v-else>
        <span class="status">{{detail.liveStatus}}</span>
        <div class="video">
          <div class="prism-player" id="player-con"></div>
        </div>
      </div>
      <div class="dphName">{{detail.dataName}}</div>
      <div class="evaluate" v-if='detail.liveStatus==="已结束"'>
        <div class="series">
          <span class="name">{{detail.seriesName}}</span>
          <i>|</i>
          <span class="grade">{{detail.credit}}分</span>
        </div>
        <div class="iconImg" v-if="detail.liveStatus == '已结束'&& detail.viewTime > 0" @click="evaluate()">
          <img src="../../../../assets/ic_rate@1x.png" />
          <div class="text">
            <span>评价</span>
          </div>
        </div>
      </div>
      <div class="firstNav">
        <firstNav @getClickFirstnav="getClickFirstnav" :navData="firstNavData" :indexs="indexs"></firstNav>
      </div>
    </div>
    <div class="heightPerch" :style="{height:height}">
    </div>
    <div class="contentDiv">
      <div v-if='indexs===0'>
        <div class="courseDetail">
          <div class="titlePlane">
            <span class="title"></span>
            <span class="plane">
              课程介绍
            </span>
          </div>
          <div class="introduceMain">
            <div class="itemMain">
              <div class="itemName">主持人</div>
              <div class="item">{{detail.hosterName}}</div>
            </div>
          </div>
          <div class="introduceMain">
            <div class="itemMain">
              <div class="itemName">会议地点</div>
              <div class="item" v-if='detail.liveLocation!==""'>{{detail.liveLocation}}</div>
              <div class="item" v-else>暂未设置</div>
            </div>
          </div>
          <div class="introduceMain">
            <div class="itemMain">
              <div class="itemName">课程时间</div>
              <div class="item">{{detail.startTime}}-{{detail.endLocalTime}}</div>
            </div>
          </div>
        </div>
        <div class="videoIntroduce">
          <div class="titlePlane">
            <span class="title"></span>
            <span class="plane">
              视频介绍
            </span>
          </div>
          <div class="introduce">
            <div v-if="detail.liveInfo" v-html="detail.liveInfo">
            </div>
            <div v-else>
              <nodata></nodata>
            </div>
          </div>
        </div>
        <div class="filePart">
          <div class="titlePlane">
            <span class="title"></span>
            <span class="plane">
              课件资料
            </span>
          </div>
          <div v-if="fileListLength===0">
            <nodata></nodata>
          </div>
          <div v-else class="fileList" v-for="(item,index) in detail.fileList" :key="index">
            <img :src="item.imgsrc" alt="">
            <div class="fileName" @click="openFile(item)"> {{item.fileName}}</div>
          </div>
        </div>
      </div>
      <div v-if='indexs===1'>
        <div class="caseLis" v-for='(item,index) in caseList' :key="index">
          <caselistCard @graphCase='graphCase' :detail='item'></caselistCard>
        </div>
      </div>
      <div v-if='indexs===2'>
        <commentDiv :datainfo='datainfo'></commentDiv>
      </div>
      <div class="itemQuseqin" v-if='detail.isOnlineExam&&detail.liveStatus==="已结束"' @click="turnAnswer()">
        <img src="../../../../assets/btn_quiz@1x.png" />
        <span>答题</span>
      </div>
    </div>
  </div>
</template>
<script>
import firstNav from '../../../../components/basics/first-nav';
import nodata from '../../../../components/basics/no-data';
import caselistCard from '../../../../components/basics/case-list-card';
import commentDiv from '../../comment/index';
export default {
  data () {
    return {
      indexs: 0,
      src: '',
      detail: {},
      fileListLength: Number,
      datainfo: {
        dataId: this.$route.query.dataId,
        moduleId: this.$route.query.moduleId
      },
      firstNavData: [
        {
          text: '课程详情',
          status: 0
        },
        {
          text: '病例资料',
          status: 1
        },
        {
          text: '讨论',
          status: 2
        }
      ],
      caseList: [],
      fileType: ['png', 'jpg', 'jpeg', 'gif', 'bmp'],
      url: '',
      height: ''
    };
  },
  created () {
    this.getDetail(this.$route.query.dataId);
    this.getCaseList(this.$route.query.dataId, this.$route.query.moduleId);
    if (localStorage.getItem('lastType') === JSON.stringify('caseCardList')) {
      this.indexs = 1;
    }
    setTimeout(() => {
      if (this.detail.dataName.length * 21 > window.innerWidth - 28) {
        if (this.detail.liveStatus === '已结束') {
          this.height = '290px'
        } else {
          this.height = '270px'
        }
      } else {
        if (this.detail.liveStatus === '已结束') {
          this.height = '270px'
        } else {
          this.height = '250px'
        }
      }
    }, 300)
  },
  methods: {
    getDetail (dataId) {
      this.$axios
        .post('edu/live/detail', {
          data: {
            id: dataId
          },
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            if (res.data.liveStatus === '进行中') {
              this.join();
            }
            res.data.fileList.forEach((element1, indexs) => {
              // 获取文件类型
              element1.file_type = element1.fileName.split('.')[1];
              element1.file_type = element1.file_type.toLowerCase();
              if (element1.file_type.indexOf('txt') !== -1) {
                element1.status = 'txt';
              } else if (
                element1.file_type.indexOf('docx') !== -1 ||
                element1.file_type.indexOf('doc') !== -1
              ) {
                element1.status = 'doc';
              } else if (
                element1.file_type.indexOf('xlsx') !== -1 ||
                element1.file_type.indexOf('xls') !== -1
              ) {
                element1.status = 'excel';
              } else if (element1.file_type.indexOf('ppt') !== -1) {
                element1.status = 'ppt';
              } else if (element1.file_type.indexOf('pdf') !== -1) {
                element1.status = 'pdf';
              } else {
                element1.status = 'img';
              }
              element1.imgsrc = this.consultHandledata.handlefileTypeicon(
                element1.status
              );
            });
            res.data.liveInfo = res.data.liveInfo.replace(/\n/g, '<br/>');
            this.detail = res.data;
            this.fileListLength = res.data.fileList.length;
            this.src = this.utils.mixedFileUrl(res.data.coverUrl);
          }
        });
    },
    // tab事件
    getClickFirstnav (e) {
      this.indexs = e;
    },
    // 获取病例
    getCaseList (dataId, moduleId) {
      this.$axios
        .post('edu/reading/case/list', {
          data: {
            readingId: dataId,
            moduleId: moduleId
          },
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            res.data.forEach((element, index) => {
              element.index = index;
            });
            this.caseList = res.data;
            if (this.caseList.length) {
            }
          }
        });
    },
    openFile (item) {
      const ext = item.fileName.substring(item.fileName.lastIndexOf('.') + 1);
      if (this.fileType.includes(ext)) {
        // @ts-ignore
        // window.open(
        //   this.utils.getFileUrl(Number(item.fileId)),
        //   '_blank'
        // );
        this.$router.push('/weblink')
        const json = {
          url: this.utils.getFileUrl(Number(item.fileId)),
          name: '查看图片'
        }
        localStorage.setItem('weblink_data', JSON.stringify(json))
      } else {
        this.downLoadFile(item.fileId);
      }
    },
    // 下载
    downLoadFile (fileId) {
      var a = document.createElement('a');
      a.style.display = 'none';
      // a.download = fileName;  //自定义名称
      // @ts-ignore
      a.href = this.baseUrl + 'file/download?fileId=' + Number(fileId);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 评价
    evaluate () {
      this.$router.push({
        path: '/search/evaluate',
        query: {
          dataId: this.$route.query.dataId,
          moduleId: this.$route.query.moduleId
        }
      });
    },
    // 在线答题
    turnAnswer () {
      this.$router.push({
        path: '/search/ques',
        query: {
          dataId: this.$route.query.dataId,
          moduleId: this.$route.query.moduleId
        }
      });
    },
    // 查看病例详情
    graphCase (caseDetail) {
      this.$router.push({
        path: '/edu_case',
        query: {
          type: 'caseCardList',
          moduleId: this.$route.query.moduleId
        }
      });
      localStorage.setItem('tempData', JSON.stringify(caseDetail));
    },
    join () {
      const version = this.$version;
      const Data = {
        id: this.$route.query.dataId
      };
      this.$axios
        .post('edu/live/get/url', { data: Data, version: version })
        .then((res) => {
          if (res.data.hoster === true) {
            this.$message('请去PC端进行推流');
          } else {
            this.url = res.data.liveUrl;
            this.info();
          }
        });
    },
    info () {
      const that = this;
      this.player = new Aliplayer(
        {
          id: 'player-con',
          source: this.url,
          width: '100%',
          height: '152px',
          autoplay: true,
          isLive: true,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: 'hover',
          useH5Prism: true
        },
        function (player) {
          // const a = player.getStatus() // 获取视频播放状态
          that.myVar = setInterval(() => {
            if (that.playStatus !== 'ended') {
              that.playStatus = player.getStatus();
              that.getPlayTime();
            } else {
              that.playStatus = player.getStatus();
              this.player.destroy();
              clearInterval(that.myVar);
            }
          }, 60000);
        }
      );
    },
    // 执行方法，传递后端直播时间
    getPlayTime () {
      const version = this.$version;
      const Data = {
        dataId: this.$route.query.dataId,
        moduleId: this.$route.query.moduleId
      };
      // @ts-ignore
      this.$axios
        .post('edu/study/history/statistic/time', {
          data: Data,
          version: version
        })
        .then((res) => {});
    },
    deactivated () {
      // 页面关闭（路由跳转）时清除定时器
      clearInterval(this.myVar);
      this.myVar = null;
      this.player.destroy();
    },
    beforeDestroy () {
      clearInterval(this.myVar);
      this.myVar = null;
      this.player.destroy();
    }
  },
  components: {
    firstNav,
    caselistCard,
    nodata,
    commentDiv
  }
};
</script>
<style lang='scss' scoped>
.live{
  margin-top:52px;
}
.contentDiv ::v-deep .imgPart img {
  margin: 0 auto;
}
.introduce {
  word-break: break-all;
}
.fixedDiv {
  position: fixed;
  z-index: 2;
  width: 100%;
}
.firstNav{
  background-color:white;
}
.coverImg {
  .video {
    width: 116%;
     height: 150px;
  }
  img {
    width: 100%;
    height: 150px;
  }
}
.firstNav ::v-deep .normalNav {
  box-shadow: none;
}
.caseLis {
  width: 49%;
  float: left;
  margin: 0px 1% 6px 0;
}
.contentDiv {
  overflow: hidden;
  padding-top: 6px;
  background-color: $white;
  .courseDetail {
    background-color: $white;
    padding: 0 14px;
  }
  .videoIntroduce {
    padding: 0 14px;
  }
  .filePart {
    padding: 14px 14px;
  }
}
.dphName {
  font-family: PingFangSC-Semibold;
  font-size: 21px;
  color: #333333;
  letter-spacing: 0.27px;
  font-weight: 600;
  padding-bottom: 6px;
  background-color: $white;
  padding: 22px 14px 6px 14px;
  border-radius: 10px 10px 0 0;
  margin-top: -9px;
  line-height:28px;
}
.series {
  font-size: 14px;
  color: #7d7d7d;
  letter-spacing: 0.18px;
  padding: 0 14px;
  background-color: $white;
  flex: 1;
}
i {
  padding: 0px 11px;
}
.title {
  width: 4px;
  height: 14px;
  background: #478ff8;
  border-radius: 2px;
  display: inline-block;
}
.plane {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.21px;
  font-weight: 600;
}
.itemName {
  float: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.18px;
  font-weight: 400;
}
.item {
  text-align: right;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.18px;
  font-weight: 400;
}
.titlePlane {
  margin: 16px 0;
}
.itemMain {
  margin-bottom: 21px;
}
.fileList {
  img {
    width: 20px;
    display: inline-block;
    float: left;
    margin: 2px 10px 0 0;
  }
  .fileName {
    font-size: 14px;
    color: #7d7d7d;
    letter-spacing: 0;
    font-weight: 400;
    margin: 14px 0;
  }
}

.enroll {
  text-align: center;
  position: fixed;
  z-index: 43;
  bottom: 17px;
  width: 100%;
  button {
    background: #478ff8;
    border-radius: 22px;
    width: 80%;
    color: $white;
    height: 44px;
  }
}
.itemQuseqin {
  width: 48px;
  height: 48px;
  background-image: linear-gradient(90deg, #529eff 0%, #3d80ff 99%);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 44;
  bottom: 64px;
  right: 10px;
  border-radius: 50%;
  text-align: center;
  img {
    display: block;
    margin: 0 auto;
    margin-top: 7px;
  }
  span {
    color: $white;
    font-size: 1px;
  }
}
.status {
  position: fixed;
  display: inline-block;
  height: 32px;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  color: #ffffff;
  padding-top: 5px;
  font-size: 14px;
  text-align: center;
}
.heightPerch {
  text-align: center;
  img {
    width: 60px;
    height: 60px;
    display: inline-block;
    margin-top: 35px;
  }
}
.noOpen {
  padding: 0 14px;
  margin-top: -110px;
}
.evaluate {
  display: flex;
  background-color: #fff;
}
.iconImg {
  margin: -6px 14px;
  img {
    padding-left: 4px;
  }
  span {
    display: block;
    font-size: 1px;
    color: #478ff8;
  }
}
</style>




